const ferries = {
  ferry: "Feri", // translated 
  ferries: "Feri", // translated 
  selectOriginPort: "Pilih Port asal", // translated 
  selectDestPort: "Pilih Pelabuhan destinasi", // translated 
  continue: "Teruskan", // translated 
  viewTimetables: "Lihat Jadual Waktu", // translated 
  operator: "Pengendali", // translated 
  cabin: "Kabin", // translated 
  cabins: "Kabin", // translated 
  place: "Tempat", // translated 
  places: "Tempat", // translated 
  seat: "Tempat duduk", // translated 
  seats: "Tempat Duduk", // translated 
  seating: "Tempat duduk", // translated 
  deckSpace: "Ruang Dek", // translated 
  compulsory: "wajib", // translated 
  departure: "Berlepas", // translated 
  total: "Jumlah", // translated 
  back: "Kembali", // translated 
  next: "Seterusnya", // translated 
  duration: "Tempoh", // translated 
  return: "Pulangan", // translated 
  prebook: "Pra-tempah", // translated 
  travelInfo: "Maklumat Perjalanan", // translated 
  book: "Buku", // translated 
  adults: "Dewasa", // translated 
  child: "Kanak-kanak", // translated 
  seniors: "Warga emas", // translated 
  senior: "Warga emas", // translated 
  to: "kepada", // translated 
  passenger: "Penumpang", // translated 
  details: "Butiran", // translated 
  currencyForTickets: "Mata wang untuk tiket-tiket ini ialah", // translated 
  seatsError: "Bilangan penumpang tidak sama dengan kapasiti.", // translated 
  title: "Tajuk", // translated 
  firstName: "Nama Pertama", // translated 
  lastName: "Nama Akhir", // translated 
  email: "E-mel", // translated 
  phone: "Telefon", // translated 
  dateOfBirth: "Tarikh Lahir", // translated 
  placeOfBirth: "Tempat Kelahiran", // translated 
  groupLeader: "Ketua Kumpulan", // translated 
  isRequired: "Diperlukan", // translated 
  charactersOnly: "Watak Sahaja", // translated 
  latinCharactersAndSpacesOnly: "Aksara Latin dan Ruang Sahaja", // translated 
  validEmail: "Bukan e-mel yang sah", // translated 
  atLeastOneAdult: "Sekurang-kurangnya 1 orang dewasa diperlukan.", // translated 
  atLeastOneSenior: "Sekurang-kurangnya 1 warga emas diperlukan.", // translated 
  toastAlert: "Sila betulkan semua ralat dalam borang di bawah.", // translated 
  backToFerriesList: "Kembali ke Senarai Feri", // translated 
  bestPrice: "Harga Terbaik", // translated 
  fastest: "Terpantas", // translated 
  beforeDeparture: "Sebelum Berlepas", // translated 
  perPerson: "setiap orang", // translated 
  notAvailableForOnlineBooking: "Tidak tersedia untuk tempahan dalam talian", // translated 
  hurryLimitedAvailability: "Cepat! Ketersediaan terhad", // translated 
  berth: "Tempat tidur", // translated 
  berths: "Tempat tidur", // translated 
  sumOfSelectionNotEqualToPersons:
    "Jumlah pilihan anda tidak sama dengan bilangan penumpang", // translated 
  attemptToBook: "Anda telah cuba menempah sejumlah", // translated 
  seatsWhenYouHave: "tempat duduk apabila anda mempunyai", // translated 
  passengersTravelling: "penumpang yang melancong", // translated 
  withReturn: "dengan tiket pergi balik", // translated 
  pleaseCorrectYourSelection: "Sila betulkan pilihan anda", // translated 
  pleaseSelectUpTo: "Sila pilih sehingga", // translated 
  accommodationTypes: "jenis penginapan", // translated 
  selectionPrices: "Harga Pilihan", // translated 
  yourCurrentTicket: "Jenis tiket semasa anda ialah", // translated 
  upgradeTo: "Naik taraf kepada", // translated 
  wouldYouLikeToUpgrade: "Adakah anda ingin menaik taraf jenis tiket anda?", // translated 
  backToTicketTypes: "Kembali ke Jenis Tiket", // translated 
  originPort: "Pelabuhan Asal", // translated 
  destinationPort: "Pelabuhan Destinasi", // translated 
  outboundDate: "Tarikh Keluar", // translated 
  inboundDate: "Tarikh Masuk", // translated 
  passengers: "Penumpang", // translated 
  hasReturn: "Mempunyai Pulangan", // translated 
  passportNumber: "Nombor Pasport", // translated 
  passportExpiryDate: "Tarikh Luput Pasport", // translated 
  passportPlaceOfIssue: "Tempat Pengeluaran Pasport", // translated 
  passportStartDate: "Tarikh Mula Pasport", // translated 
  cityCode: "Kod Bandar", // translated 
};







export default ferries;
